import { useEffect } from 'react';

import { useRepository } from '@/Application/Providers/Repository/Repository';
import { extractCartItemSkus } from '@/modules/shared/utils/getCartSkus';

const useShippingPageInitializer = () => {
  const repositories = useRepository();

  useEffect(() => {
    const initializeShippingData = async () => {
      try {
        await repositories.tokenUserIdRepository.getTokenUserId();

        const cart = await repositories.cart.get();
        if (!cart?.lineItems?.length) {
          return;
        }

        const cartSkus = extractCartItemSkus(cart);
        await repositories.shippingMethodsRepository.getGeneralShippingMethods(
          cartSkus
        );
      } catch (error) {
        console.error('Error initializing shipping page:', error);
      }
    };

    initializeShippingData();
  }, [repositories]);
};

export default useShippingPageInitializer;
